import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './modules/core/core.module';
import { OrdersModule } from './modules/orders/orders.module';
import { ReportsModule } from './modules/reports/reports.module';
import { SharedModule } from './modules/shared/shared.module';
import { LibraryModule } from './modules/library/library.module';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router'
import { appVersion } from './app-version';

registerLocaleData(localePl);

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, ScrollToModule.forRoot(), AppRoutingModule, CoreModule, OrdersModule, LibraryModule, SharedModule, ReportsModule, FormsModule, ReactiveFormsModule, ModalModule.forRoot()],
  providers: [
    { provide: LOCALE_ID, useValue: 'pl' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'PLN' },
    { provide: ErrorHandler,  useValue: Sentry.createErrorHandler() },
    { provide: Sentry.TraceService, deps: [Router] },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
    constructor(trace: Sentry.TraceService) {
      console.info(`Version: ${ appVersion }`);
    }
}
